<template>
  <div>
    <f-row
      class="wrapper"
      ref="wrapper"
      :style="{
        transform: `translateX(-${currentIndex * (swiperItemWidth + gap)}px)`,
      }"
    >
      <slot></slot>
    </f-row>
    <f-row class="control-wrapper" justify="space-between" aligner="middle">
      <div class="progress">
        <div
          class="progress-slider"
          :style="{
            width: `${sliderWidth}px`,
            transform: `translateX(${currentIndex * sliderWidth}px)`,
          }"
        ></div>
      </div>
      <div class="page-turn-button">
        <img
          @click="pre"
          :class="['pre', 'page-btn', currentIndex === 0 ? 'disabled' : '']"
          src="@/assets/images/design-arrow.webp"
          alt=""
        />
        <img
          @click="next"
          :class="[
            'next',
            'page-btn',
            currentIndex === c_total - 1 ? 'disabled' : '',
          ]"
          src="@/assets/images/design-arrow.webp"
          alt=""
        />
      </div>
    </f-row>
  </div>
</template>
<script>
export default {
  emits: ['click'],
  model: {
    prop: 'index',
    event: 'change',
  },
  props: {
    total: {
      type: Number,
      default: 7,
    },
    gap: {
      type: Number,
      default: 25,
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      progressWidth: 0,
      swiperItemWidth: 0,
      wrapperWidth: 0,
      currentIndex: 0,
    }
  },
  computed: {
    sliderWidth() {
      return (1 / this.c_total) * this.progressWidth
    },
    c_total() {
      return this.total
    },
  },
  watch: {
    index(current) {
      this.currentIndex = current
    },
  },
  mounted() {
    this.resizeChange()
    window.addEventListener('resize', this.resizeChange)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeChange)
  },
  methods: {
    pre() {
      if (this.$props.index === 0) return
      this.$emit('change', this.$props.index - 1)
    },
    next() {
      if (this.$props.index === this.c_total - 1) return
      this.$emit('change', this.$props.index + 1)
    },
    resizeChange() {
      this.progressWidth = document.querySelector('.progress').clientWidth
      this.swiperItemWidth =
        document.querySelector('.swiper-item-card').clientWidth
      this.wrapperWidth = document.querySelector('.wrapper').clientWidth
    },
  },
}
</script>
<style scoped lang="less">
.wrapper {
  transition: all 0.4s ease;
  > div {
    flex-grow: 0;
    flex-shrink: 0;
  }
}
.control-wrapper {
  margin-top: 55px; /* rc sm:48px; */
  flex-wrap: wrap; /* rc:extract sm; */
}
.progress {
  width: 364px; /* rc:only sm:100%; */
  height: 4px;
  background: #292524;
  border-radius: 4px;
  .progress-slider {
    background: #7d7777;
    height: 100%;
    border-radius: 4px;
    transition: all 0.4s ease;
  }
}
.page-turn-button {
  display: flex;
  .page-btn {
    width: 48px; /* rc sm:40px; */
    border-radius: 50%;
    background: #7d7777;
    cursor: pointer;
    &.disabled {
      background: #292524;
      cursor: not-allowed;
    }
  }
  .next {
    transform: rotateZ(180deg);
    margin-left: 13px;
  }
}
</style>
